import { Menu } from 'antd';
import { styled } from 'styled-components';
import { theme } from '@tailwindConfig';
import { THEME } from '@src/store/layout/layoutSlice';

export const StyledMenuItem = styled(Menu.Item)`
    display: flex;
    align-items: center;
    .ant-menu-item {
        color: inherit !important;
    }
    &.ant-menu-item-selected {
        background: #233ac6 !important;
        font-weight: bold !important;
        color: #ffffff !important;
    }

    .ant-menu-inline-collapsed .ant-menu-item-selected::before {
        transform: scale(0.9);
    }
`;
export const StyledSubMenuItem = styled(Menu.SubMenu)`
    &.ant-menu-submenu-active {
        background-color: transparent !important;
    }
    .ant-menu-sub {
        background: transparent !important;
    }
    .ant-menu-submenu-title {
        color: inherit !important;
    }
    .ant-menu-item:hover {
        background-color: transparent !important;
        color: ${theme.extend.colors.infoHover} !important;
    }
    .ant-menu-submenu-title:active {
        background-color: transparent !important;
        color: ${theme.extend.colors.infoHover} !important;
    }
    .ant-menu-submenu-title:hover {
        background-color: transparent !important;
        color: ${theme.extend.colors.infoHover} !important;
    }
    &.ant-menu-submenu-selected {
        .ant-menu-submenu-title {
            font-weight: bold !important;
            background: transparent !important;
            color: ${theme.extend.colors.info} !important;
        }
        .ant-menu-item-selected {
            color: ${theme.extend.colors.info} !important;
            border-radius: 0 !important;
            background: transparent !important;
            position: relative;
            > .ant-menu-submenu-title {
                color: ${theme.extend.colors.info} !important;
            }
            &::before {
                content: '';
                width: 6px;
                background-color: ${theme.extend.colors.info} !important;
                border-radius: 20px !important;
                height: 32px;
                position: absolute;
                left: 0px;
                z-index: 10;
                top: 4px;
            }
        }
    }
    &.ant-menu-submenu-title:hover {
        color: ${theme.extend.colors.infoHover} !important;
    }
`;

export const StyledMenu = styled(Menu)`
    &.ant-menu {
        cursor: pointer;
        background-color: ${(props) =>
            props.theme === THEME.DARK
                ? theme.extend.colors.navyBgBlue
                : theme.extend.colors.white} !important;
    }

    .ant-menu-submenu-disabled,
    .ant-menu-item-disabled {
        color: ${(props) =>
            props.theme === THEME.DARK
                ? 'rgba(256, 256, 256, 0.55)'
                : 'rgba(0, 0, 0, 0.25)'} !important;
    }

    &.ant-menu .ant-menu-submenu-title .ant-menu-item-icon + span {
        transition:
            opacity 0.1s cubic-bezier(0.645, 0.045, 0.355, 1),
            margin 0.3s,
            color 0.3s !important;
    }

    .ant-menu-item,
    .ant-menu-submenu,
    .ant-menu-submenu-title {
        margin-inline: 0 !important;
    }
    .ant-menu-sub {
        background-color: transparent !important;
    }
    a {
        transition: none !important;
    }

    .ant-menu-item-divider {
        margin-top: 16px;
        margin-bottom: 16px;
        margin-inline: ${(props) =>
            props.theme === THEME.DARK ? '1rem' : 0} !important;
        border-color: rgba(117, 122, 141, 0.3) !important;
    }

    .ant-menu-item {
        &.ant-menu-item-selected {
            background: transparent !important;
            color: ${theme.extend.colors['purple']} !important;
            font-weight: bold !important;
            &::before {
                content: '';
                width: 6px;
                background-color: ${theme.extend.colors['purple']} !important;
                border-radius: 20px !important;
                height: 32px;
                position: absolute;
                left: 0px;
                z-index: 10;
            }
        }
        &.ant-menu-item {
            transition:
                border-color 0.3s,
                background 0.3s,
                padding 0.2s cubic-bezier(0.215, 0.61, 0.355, 1),
                color 0.05s cubic-bezier(0.215, 0.61, 0.355, 1) !important;
        } //border-color 0.3s,background 0.3s,padding 0.2s cubic-bezier(0.215, 0.61, 0.355, 1)
        &.ant-menu-item:hover {
            background-color: transparent !important;
            color: ${theme.extend.colors['purpleHover']} !important;
            padding-left: 15px !important;
        }
    }

    .ant-menu-submenu {
        &.ant-menu-submenu-selected {
            background: transparent !important;
            .ant-menu-item-selected {
                color: ${theme.extend.colors['purple']} !important;
                background-color: transparent !important;
                position: relative;
                margin: 4px 0 !important;
            }
            .ant-menu-item-selected::before {
                content: '';
                width: 6px;
                background-color: ${theme.extend.colors['purple']} !important;
                border-radius: 20px !important;
                height: 32px;
                position: absolute;
                left: 0px;
                z-index: 10;
            }
            > .ant-menu-submenu-title {
                font-weight: bold !important;
                color: ${theme.extend.colors['purple']} !important;
            }
        }
        .ant-menu-submenu-title {
            transition:
                border-color 0.3s,
                background 0.3s,
                padding 0.2s cubic-bezier(0.215, 0.61, 0.355, 1),
                color 0.05s cubic-bezier(0.215, 0.61, 0.355, 1) !important;

            a:hover {
                color: ${theme.extend.colors['purpleHover']} !important;
            }
        }
        .ant-menu-submenu-title:hover {
            background-color: transparent !important;
            padding-left: 15px !important;
            color: ${theme.extend.colors['purpleHover']} !important;
        }
        &.ant-menu-submenu-active {
            background-color: transparent !important;
        }
        .ant-menu-item {
            transition:
                border-color 0.3s,
                background 0.3s,
                padding 0.2s cubic-bezier(0.215, 0.61, 0.355, 1),
                color 0.05s cubic-bezier(0.215, 0.61, 0.355, 1) !important;
        }
        .ant-menu-item:hover {
            background-color: transparent !important;
            color: ${theme.extend.colors['purpleHover']} !important;
            padding-left: 40px !important;
        }
    }

    .ant-menu-submenu {
        .ant-menu-submenu {
            .ant-menu-submenu-title:hover {
                padding-left: 40px !important;
                color: ${theme.extend.colors['purpleHover']} !important;
            }

            .ant-menu-item:hover {
                padding-left: 64px !important;
            }
        }
    }

    &.ant-menu-inline-collapsed .ant-menu-item-selected::before {
        transform: scale(0.9);
    }
`;
